export default "__VITE_ASSET__D8kYjo7d__"